module.exports = __webpack_public_path__ + "files/341d06a4e61d00d52ffb543af06bf439.png";